import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'
import { ImageLink } from '../constants'
import CommonEditor from './CommonEditor'

const AddProjectSpecification = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state

    const [projectData, setProjectData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);

    const [data, setData] = useState({
        projectId: editData?.projectId?._id || '',
        title: editData?.title || '',
        description: editData?.description || '',
        position: editData?.position || '',
        desktopImg: editData?.desktopImg || '',
        categoryId: editData?.categoryId?._id || '',
    });

    const [errors, setErrors] = useState({
        projectId: '',
        title: '',
        description: '',
        position: '',
        desktopImg: '',
        categoryId: '',
    });

    const handleChange = (e) => {
        const { name, files, value } = e.target;
        if (name === 'desktopImg') {
            setData({ ...data, [name]: files.length > 0 ? files[0] : null });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        // Validate email
        if (!data.projectId.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectId: 'Project is required'
            }));
            hasErrors = true;
        }
        if (!data.title.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                title: 'Title is required'
            }));
            hasErrors = true;
        }
        // if (!data.description.trim()) {
        //     setErrors((prevErrors) => ({
        //         ...prevErrors,
        //         description: 'Description is required'
        //     }));
        //     hasErrors = true;
        // }
        if (!data.position.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                position: 'Position is required'
            }));
            hasErrors = true;
        }
        if (!data.desktopImg) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                desktopImg: 'Desktop img is required'
            }));
            hasErrors = true;
        }
        if (!data.categoryId) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                categoryId: 'Category is required'
            }));
            hasErrors = true;
        }

        // If there are errors, stop further processing
        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("projectId", data.projectId);
            formData.append("title", data.title);
            formData.append("position", data.position);
            if (data.desktopImg instanceof File) {
                formData.append("desktopImg", data.desktopImg);
            }
            formData.append("description", data.description);
            formData.append("categoryId", data.categoryId);

            const response = await axiosInstance.post(`project/createProjectSpec`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/specification");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("projectId", data.projectId);
            formData.append("title", data.title);
            formData.append("position", data.position);
            if (data.desktopImg instanceof File) {
                formData.append("desktopImg", data.desktopImg);
            }
            formData.append("description", data.description);
            formData.append("categoryId", data.categoryId);

            const response = await axiosInstance.put(`project/updateProjectSpec/${editData?._id}`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/specification");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`project/getWithoutPaginationProject`);
            const { data } = response.data;
            setProjectData(data);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const fetchDataCategory = async () => {
        try {
            const response = await axiosInstance.get(`project/getWithoutPaginationProjectCategory`);
            const { data } = response.data;
            setCategoryData(data);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    useEffect(() => {
        fetchData();
        fetchDataCategory();
    }, []);


    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5">
                    <h3 className="page-title">Add Specification</h3>
                </div>
                <div className="row grid-margin stretch-card">
                    <div className="col-md-8  ">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername1"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project
                                        </label>
                                        <div className="col-sm-9">
                                            <select
                                                className="form-control form-control-lg"
                                                id="exampleFormControlSelect1"
                                                name='projectId'
                                                value={data.projectId}
                                                onChange={handleChange}
                                            >
                                                <option value="" disabled>-- Please Select Project --</option>
                                                {projectData.map(item => (
                                                    <option key={item._id} value={item._id}>{item.title}</option>
                                                ))}
                                            </select>
                                            {errors.projectId && <p className="text-danger">{errors.projectId}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Position
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="position"
                                                name="position"
                                                placeholder="Enter position"
                                                value={data.position}
                                                onChange={handleChange}
                                            />
                                            {errors.position && <p className="text-danger">{errors.position}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Title
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="title"
                                                name="title"
                                                placeholder="Enter title"
                                                value={data.title}
                                                onChange={handleChange}
                                            />
                                            {errors.title && <p className="text-danger">{errors.title}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Description
                                        </label>
                                        <div className="col-sm-9">
                                            <CommonEditor
                                                value={data.description}
                                                placeholder='Enter content ...'
                                                onChange={(value) => handleChange({ target: { name: 'description', value } })}
                                            />
                                            {/* {errors.description && !data?.description?.trim() && (
                                                <div className="text-danger">Description is required</div>
                                            )} */}
                                            {/* <textarea
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="description"
                                                name="description"
                                                placeholder="Enter description"
                                                value={data.description}
                                                onChange={handleChange}
                                                style={{ height: '150px' }}
                                            />
                                            {errors.description && <p className="text-danger">{errors.description}</p>} */}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Desktop Img
                                        </label>

                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="desktopImg"
                                                name="desktopImg"
                                                placeholder="Enter desktop img"
                                                // value={data.desktopImg}
                                                onChange={handleChange}
                                            />
                                            {errors.desktopImg && <p className="text-danger">{errors.desktopImg}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername1"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Category
                                        </label>
                                        <div className="col-sm-9">
                                            <select
                                                className="form-control form-control-lg"
                                                id="categoryId"
                                                name='categoryId'
                                                value={data.categoryId}
                                                onChange={handleChange}
                                            >
                                                <option value="" disabled>-- Please Select Category --</option>
                                                {categoryData.map(item => (
                                                    <option key={item._id} value={item._id}>{item.title}</option>
                                                ))}
                                            </select>
                                            {errors.categoryId && <p className="text-danger">{errors.categoryId}</p>}
                                        </div>
                                    </div>
                                    <div className='text-center mt-4'>
                                        <Link to="/specification"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 stretch-card">
                        <div className="card">
                            {data.desktopImg &&
                                <div className="w-100 h-80 text-center mb-4">
                                    <p className="mt-3">Image Preview</p>
                                    <br />
                                    {data.desktopImg instanceof File ? (
                                        <img src={URL.createObjectURL(data.desktopImg)} alt="Preview" className="w-30" style={{ backgroundColor: '#03245b', padding: '10px' }} />
                                    ) : (
                                        <img src={ImageLink(data.desktopImg)} alt="Preview" className="w-30" style={{ backgroundColor: '#03245b', padding: '10px' }} />
                                    )}
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddProjectSpecification;